<template>
  <div class="check-delivery">
    <div class="row">
      <div class="col-12 col-lg-7 offset-lg-5">
        <div class="check-delivery_inner">
          <p>Проверить зону доставки</p>
          <div class="check-delivery_form">
            <div class="check-delivery_form_input">
              <street-input
                @selected="onSelectStreet"
                v-model="streetFull"
                placeholder="Поселок, микрорайон, улица"
              />

              <house-input
                :disabled="isHouseInputDisabled"
                :streetId="streetId"
                v-model="house"
                :val="house"
                @selected="onSelectHouse"
                placeholder="Дом"
              />
            </div>
            <div class="check-delivery_form_submit">
              <Button @click="checkAddress" :disabled="!acceptCheckAddress">
                Проверить адрес
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal :open="modalOpen" @close="modalOpen = false" :initialWidth="isApply ? '404px' : null">
      <ModalCheckDelivery
        :isApply="isApply"
        :delivery="checkedDeliveryData"
        @close-modal="modalOpen = false"
      />
    </Modal>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import InputText from '@/components/UI/InputText'
import LocationInput from '@/components/UI/LocationInput'
import Modal from '@/components/page/Modal/Modal'
import ModalCheckDelivery from '@/components/page/Modal/ModalCheckDelivery'
import _ from 'lodash'
import StreetInput from '~/components/page/Modal/StreetInput'
import HouseInput from '~/components/page/Modal/HouseInput'

export default {
  components: { Button, InputText, LocationInput, Modal, ModalCheckDelivery, HouseInput, StreetInput },
  data () {
    return {
      street: '',
      streetFull: '',
      house: '',
      latitude: null,
      longitude: null,

      streetObj: {},
      houseObj: {},

      isApply: false,
      address: '',
      modalOpen: false,
      checkedDeliveryData: {},
      city: null,
    }
  },
  computed: {
    isHouseInputDisabled () {
      return _.isEmpty(this.streetObj)
    },
    streetId () {
      return this.streetObj.id
    },
    hasGeoData () {
      return this.longitude && this.latitude
    },
    acceptCheckAddress () {
      return !this.isHouseInputDisabled && this.house
    },
    fullStreetString () {
      return this.streetObj.fullAddress || ''
    },
    fullAddress () {
      return this.fullStreetString + ', ' + this.house
    },
  },
  watch: {
    house (newValue) {
      if (this.houseObj && this.houseObj.value != this.house) {
        this.clearHouseObj()
      }
    },
    streetFull (newValue) {
      if (this.streetObj && this.streetObj.value != newValue) {
        /* console.log({
          clear: true,
          full: this.streetFull,
          obj: this.streetObj.value,
        }) */
        this.clearStreetObj()
        this.clearHouseObj()
        this.house = null
      }
    },
  },
  methods: {
    onSelectStreet (obj) {
      // console.log({ selectStreet: obj })
      this.streetObj = obj
      this.street = obj.name
    },
    onSelectHouse (obj) {
      // console.log({ selectHouse: obj })
      this.clearHouseObj()

      this.houseObj = obj
      if (obj.hasGeo) {
        this.latitude = obj.latitude
        this.longitude = obj.longitude
      }
    },
    clearHouseObj () {
      this.houseObj = {}
      this.latitude = null
      this.longitude = null
      this.success = false
      this.error = false
    },
    clearStreetObj () {
      this.streetObj = {}
      this.street = null
      this.streetFull = null
      this.house = null
    },
    checkAddress () {
      const payload = {}

      if (this.hasGeoData) {
        payload.lat = this.latitude
        payload.let = this.longitude
      } else {
        payload.address = this.fullAddress
      }

      /* this.$store.dispatch('common/getSuggestAddress', payload).then(data => {
        this.open = !this.open;
        const { city } = data.find(sug => sug.street === this.address); */

      this.$store.dispatch('common/checkAddressIsDeliveryByString', payload).then((res) => {
        this.isApply = true
        this.checkedDeliveryData = res.data
      }).catch((err) => {
        this.isApply = false
        this.checkedDeliveryData = {}
        console.warn('Error', err)
      }).finally(() => {
        this.modalOpen = true
      })
    },
  },
}
</script>

<style lang="less">
.check-delivery {
  width: 100%;
  min-height: 200px;
  //display: flex;
  //justify-content: flex-end;
  background: url('~assets/s-images/delivery/car-sushiset-359x185.png'), /*url('/wave.png'),*/ white;
  background-size: contain;
  background-position: top left 16px, top left;
  background-repeat: no-repeat;
  padding: 28px 0 28px 0;
  border-radius: 15px;
  box-shadow: 0 3px 36px rgba(122, 122, 122, .16);
  box-sizing: border-box;

  @media screen and (max-width: 992px) {
    background: url('~assets/s-images/delivery/car-sushiset-359x185.png');
    background-size: auto;
    background-position: top center;
    background-repeat: no-repeat;
    padding: 192px 6px 0 6px;
    box-shadow: none;
    border-radius: 0;
  }

  &_inner {
    /*flex-basis: 58.6%;
    flex-grow: 0;*/
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-right: 20px;

    @media screen and (max-width: 992px) {
      flex-basis: 100%;
    }

    & > p {
      display: block;
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      font-size: 30px;
      margin-bottom: 25px;
      margin-left: 20px;

      @media screen and (max-width: 992px) {
        text-align: center;
        margin-bottom: 30px;
      }
    }
  }

  &_form {
    display: flex;
    align-items: stretch;
    width: 100%;

    @media screen and (max-width: 992px) {
      flex-direction: column;
      align-items: center;
    }

    &_input {
      display: flex;
      flex-grow: 1;
      margin-right: 15px;
      margin-left: 0;

      .street-input-component {
        flex-grow: 1;
        margin-right: 15px;
        position: relative;

        .vue-simple-suggest {
          .suggestions {
            width: calc(100% + 120px + 15px)
          }
        }
      }

      .house-input-component {
        flex-basis: 120px;
        flex-shrink: 1;
        position: relative;

        .vue-simple-suggest {
          .suggestions {
            bottom: auto;
            top: 100%;
            width: calc(100% + 15px);
          }

        }
      }

      .input-text_input {
        padding-left: 15px;
        padding-right: 15px;
        font-weight: 500;
        color: black;
      }

      @media screen and (max-width: 992px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;

        & > * {
          width: 100%;
        }

        input {
          &, &::placeholder {
            font-weight: 300;
            text-align: center;
          }
        }
      }

      &--street {
        flex-grow: 1;
        margin-right: 15px;
      }

      &--house {
        max-width: 150px;
        flex-basis: 150px;
      }
    }

    &_submit {
      flex-grow: 0;
      flex-basis: 125px;

      .button {
        min-width: 125px;

        &:disabled {
          background: linear-gradient(to bottom, #eaeaea 0%, rgba(145, 145, 145, 0.5) 100%);
          color: inherit;
          opacity: 0.4;
        }

      }

      @media screen and (max-width: 992px) {
        width: 100%;

        & > * {
          width: 100%;
        }

      }
    }
  }

}
</style>
